module.exports = __webpack_public_path__ + "media/images/pic/hero/courses/online/youth-6b9d2f7a7967305f721494105e6ef737.jpeg";